module.exports = __webpack_public_path__ + "static/img/news8_11.73ca78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news8_11.png
// module id = O2JB
// module chunks = 0